module.exports = __webpack_public_path__ + "img/tajikistan.10e318c9.png";